// Router-state key the lot detail page uses to ask the transit orders
// page to open the New OT wizard pre-seeded with a specific lot.
export const NEW_OT_LOT_STATE_KEY = "newOTLotId"

export interface NewOTLotState {
  [NEW_OT_LOT_STATE_KEY]?: number
}
